import { TReminderStatus } from '../../types'
import { TApiReminderStatus } from '../../types/api'

export const reminderStatusTransformer = (
  apiStatus: TApiReminderStatus,
): TReminderStatus | undefined => {
  if (apiStatus === null) {
    return undefined
  }

  if (['processed', 'sent', 'unknown'].includes(apiStatus)) {
    return 'pending'
  }

  if (['read', 'delivered', 'unknown'].includes(apiStatus)) {
    return 'delivered'
  }

  return 'failed'
}
